import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import { RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Image2 } from '../../Image2/Image2';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import './AddTitleExtensionRecommendationCard.css';
import * as keyset from './AddTitleExtensionRecommendationCard.i18n';
import * as titleExtensionExample1x from './TitleExtensionExample@1x.jpg';
import * as titleExtensionExample2x from './TitleExtensionExample@2x.jpg';
import * as titleExtensionExample3x from './TitleExtensionExample@3x.jpg';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    bannersNumber: number;
    bannersPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type AddTitleExtensionRecommendationCardProps = RecommendationsPopupViewProps | NormalViewProps;

export class AddTitleExtensionRecommendationCard extends React.Component<AddTitleExtensionRecommendationCardProps> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.addTitleExtension}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                view={view}
                isInProgress={false}
                buttons={this.getButtons()}
                onShow={onShow}
            >
                {this.getBody()}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title-hint');
        }

        return i18n('normal-view-title-hint');
    };

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('popup-view-title');
        }

        return i18n('normal-view-title');
    };

    private getBody = () => {
        return (
            <>
                <div className={Bem.cls('add-title-extension-recommendation-card', 'example-wrapper')}>
                    <Image2
                        src={{
                            src: titleExtensionExample1x,
                            src2x: titleExtensionExample2x,
                            src3x: titleExtensionExample3x
                        }}
                        cls={Bem.cls('add-title-extension-recommendation-card', 'example')}
                    />
                </div>

                <p className={Bem.cls('add-title-extension-recommendation-card', 'body-text')}>
                    {i18nRaw('title-extension-desc1', {
                        desktopValue: (
                            <b key={1} className={Bem.cls('add-title-extension-recommendation-card', 'sign-text')}>
                                {i18n('percent-value', { value: 5 })}
                            </b>
                        ),
                        mobileValue: (
                            <b key={2} className={Bem.cls('add-title-extension-recommendation-card', 'sign-text')}>
                                {i18n('percent-value', { value: 10 })}
                            </b>
                        )
                    })}
                </p>

                <p className={Bem.cls('add-title-extension-recommendation-card', 'body-text')}>
                    {i18n('title-extension-desc2')}
                </p>
            </>
        );
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { bannersNumber, bannersPageUrl } = this.props;
        const formattedItemsLength = formatNumber(bannersNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-banner-button', {
                    count: formattedItemsLength
                })
            ],
            bannersNumber
        );

        return [<Button key={1} theme={'action'} size={'n'} text={buttonText} type={'link'} url={bannersPageUrl} />];
    };
}
